import axios from 'axios'
import config from '../config'

const getMarkers = async () => {
  const responce = await axios.get(`${config.MAP_SERVER}/map.json`)
  //console.log('Markkinat',responce.data)
  return responce.data
}

export default getMarkers
